import React from "react";
import { Check } from "lucide-react";

interface StepperProps {
  currentStep: number;
  steps: string[];
}

const Stepper: React.FC<StepperProps> = ({ currentStep, steps }) => {
  return (
    <div className="w-full">
      {/* Desktop/tablet: full stepper */}
      <ul className="hidden sm:flex relative w-full justify-between items-center mb-6">
        {steps.map((label, index) => {
          const step = index + 1;
          const completed = currentStep > step;

          return (
            <li
              key={step}
              className={`flex items-center gap-x-2 ${index < steps.length - 1 ? "flex-1" : ""}`}
            >
              <div className="flex items-center">
                <span
                  className={`size-8 flex justify-center items-center rounded-full ${currentStep >= step ? "bg-primary text-white" : "bg-gray-100 text-gray-800"
                    }`}
                >
                  {completed ? <Check className="h-5 w-5" /> : step}
                </span>
                <span className="ml-2 text-sm font-medium text-gray-800 dark:text-neutral-200 whitespace-nowrap">
                  {label}
                </span>
              </div>
              {index < steps.length - 1 && <div className="flex-grow h-px bg-gray-300 mx-3" />}
            </li>
          );
        })}
      </ul>

      {/* Mobile: only current and last */}
      <ul className="sm:hidden flex w-full justify-between items-center mb-4">
        {[currentStep, steps.length].map((stepIdx, i) => {
          const label = steps[stepIdx - 1];
          const isCurrent = stepIdx === currentStep;

          return (
            <li key={stepIdx} className={`flex items-center ${i === 0 ? "flex-1" : ""}`}>
              <div className="flex items-center">
                <span
                  className={`size-8 flex justify-center items-center rounded-full ${isCurrent ? "bg-primary text-white" : "bg-gray-100 text-gray-800"
                    }`}
                >
                  {stepIdx}
                </span>
                <span className="ml-2 text-xs font-medium text-gray-800 whitespace-nowrap">
                  {label}
                </span>
              </div>
              {i === 0 && <div className="flex-grow h-px bg-gray-300 mx-3" />}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Stepper;
